
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#27AE60"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5","d":"M23.104 27.297c3.35-.842 5.84-3.738 5.84-7.214 0-3.462-2.477-6.373-5.84-7.214m-5.208 0c-3.363.828-5.84 3.738-5.84 7.214 0 3.462 2.477 6.372 5.84 7.214"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5","d":"M23.61 11.034l-2.462 1.614 1.83 2.249m-5.841 14.068l2.477-1.6-1.83-2.261"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-width":"1.5","d":"M18 20.2l1.625 1.3c.366.292.884.292 1.25 0L24 19"}})])
          )
        }
      }
    